function isAnyPartOfElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
    return (vertInView && horInView);
}

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase()
}

let miniCartOpened = false
let checkElements = [document.getElementById("mini-cart-desktop-info"), document.getElementById("mini-cart-info"), document.querySelector("#shopify-section-ziv-header > div > div > div.right-bar > a.display-block")]
const main = () => {
  setTimeout(function asyncCode() {
    // Everything what comes inside asyncCode function will be executed after the page is totally rendered
    const closeCartSelectors = [...document.querySelectorAll(".mini-cart-close"), ...document.querySelectorAll("[data-close=\"mini-cart-info\"]")]
    const continueShoppingButtons = document.querySelectorAll(".continue-shopping")


    activateContinueShoppingBehaviour(closeCartSelectors, continueShoppingButtons)
    activateMobileBlurOnMiniCart(closeCartSelectors, continueShoppingButtons)

    processLoadingBtns()
  }, 60)
}


const processLoadingBtns = () => {
  // console.log([...document.querySelectorAll("[loading-btn]")])

  ;[...document.querySelectorAll("[loading-btn]")].forEach((btn) => {
    if (btn.getAttribute("listener") !== "true") {
      btn.addEventListener("click", addLoader, false)
      btn.setAttribute("listener", "true")
    }
  })
}

const activateContinueShoppingBehaviour = (closeCartSelectors, continueShoppingButtons) => {
  const cb = (btn) => (event) => {
    event.preventDefault()
    event.stopPropagation()

    closeCartSelectors.forEach(e => e.click())
  }

  continueShoppingButtons.forEach(btn => btn.addEventListener("click", cb(btn), null))
}

const activateMobileBlurOnMiniCart = (closeCartSelectors, continueShoppingButtons) => {
  const mobileBody = document.querySelector(".bkghomepage")
  const mobileCartButton = document.querySelector("#shopify-section-ziv-header > div > div > div.right-bar > a.display-block")

  mobileCartButton.addEventListener("click", () => {
    miniCartOpened = true
    mobileBody.classList.add("filter-blur", "filter-dark")
  }, null)

  window.continueShopping = (e) => {
    e.preventDefault()
    miniCartOpened = false
    mobileBody.classList.remove("filter-blur", "filter-dark")
  }

  ;[...closeCartSelectors, ...continueShoppingButtons].forEach(btn => btn.addEventListener("click", window.continueShopping, null))

  window.addEventListener("click", event => {
    miniCartOpened = mobileBody.classList.contains("filter-dark")

    if (!miniCartOpened) return

    if (checkElements.find(el => el.contains(event.target))) return
    
    mobileBody.classList.remove("filter-blur", "filter-dark")
  }, null)
}


window.onload = main

$(document).on('click', '[data-close="mini-cart-info"], [data-close="mini-cart-desktop-info"], .continue-shopping', function(e) {
  $('#mini-cart-info').fadeOut();
  window.continueShopping(e);
  
});

$(document).on('click', '[data-toggle="mini-cart-info"]', function(e) {
  e.preventDefault();
  $('#mini-cart-info').fadeIn();
});


processLoadingBtns()

function imageAltWithoutData(alt = '') {
  if(!alt) return '';
  return alt.split(' data-')[0];
}

function imageAltDataAttributes(alt = '') {
  if(!alt) return '';
  var altWithoutData = imageAltWithoutData(alt);
  var dataAttributes = alt.replace(altWithoutData, '').trim().replaceAll('=', '="').replaceAll(' data-', '" data-') + '"';
  return dataAttributes;
}